var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Dialog",
        _vm._g(
          _vm._b(
            { attrs: { visible: _vm.show, title: _vm.locale.joinCivi } },
            "Dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("h3", [
            _vm._v(_vm._s(_vm._f("formatter")(_vm.locale.isJoin, _vm.name))),
          ]),
          _c("p", [_vm._v(_vm._s(_vm.locale.cannotChange))]),
          _c(
            "button",
            {
              directives: [
                {
                  name: "gtag",
                  rawName: "v-gtag:joinConfirm",
                  arg: "joinConfirm",
                },
              ],
              staticClass: "dialog-btn join-civi",
              attrs: { "data-type": "button" },
              on: {
                click: function ($event) {
                  return _vm.join("join")
                },
              },
            },
            [
              _c("span", [
                _vm.loading
                  ? _c("i", { staticClass: "loading el-icon-refresh-right" })
                  : _vm._e(),
                _vm._v("\n        " + _vm._s(_vm.locale.confirm)),
              ]),
            ]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "gtag",
                  rawName: "v-gtag:joinCancel",
                  arg: "joinCancel",
                },
              ],
              staticClass: "think-again",
              attrs: { "data-type": "link" },
              on: {
                click: function ($event) {
                  return _vm.join("close")
                },
              },
            },
            [_vm._v(_vm._s(_vm.locale.cancel))]
          ),
        ]
      ),
      _c("DlgShare", {
        attrs: {
          title: _vm.$locale.dialog.joinedSuccess.success,
          content: _vm.$locale.dialog.joinedSuccess.toShare,
          name: _vm.name,
          visible: _vm.joinedShow,
        },
        on: {
          close: function ($event) {
            return _vm.joined("close")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }